/**
 * 見る専用（?watch=1。Issue #617）の下端の帯。再生 / 一時停止・5 秒戻す・時刻・「ライブへ」だけ（入力の操作は置かない）。
 * iPhone の縦でも 1 行に収まる数に絞っている。表示の切り替え（全体 / フィールド / 手札）は盤面の下端（StageView）。
 */
import { fmtTime } from './PlaybackTab';
import LiveButton from './LiveButton';

const b = (primary = false) => ({
  minHeight: 40, minWidth: 44, padding: '4px 10px', borderRadius: 8, fontSize: 14, cursor: 'pointer', color: '#e8eefc', whiteSpace: 'nowrap', flexShrink: 0,
  border: `1px solid ${primary ? '#4fc3ff' : '#345'}`, background: primary ? '#1b4a6d' : '#151c30',
});

export default function WatchBar({ time = { t: 0, d: 0, paused: true }, hasVideo = false, live = null, onBack, onPlayPause, onSkip }) {
  return (
    <div data-testid="watch-bar" style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 8px', paddingBottom: 'max(6px, env(safe-area-inset-bottom))',
      borderTop: '1px solid #1c2440', background: '#0a0f1e', fontVariantNumeric: 'tabular-nums', fontSize: 13, flexShrink: 0 }}>
      {onBack ? <button type="button" aria-label="戻る" style={{ ...b(), border: 'none', background: 'none', color: '#8896b3', fontSize: 18 }} onClick={onBack}>←</button> : null}
      <button type="button" data-testid="watch-toggle" style={{ ...b(true), fontSize: 16 }} disabled={!hasVideo} onClick={onPlayPause} aria-label={time.paused ? '再生' : '一時停止'}>{time.paused ? '▶' : '❚❚'}</button>
      <button type="button" style={b()} disabled={!hasVideo} onClick={() => onSkip?.(-5)} aria-label="5 秒戻す">−5s</button>
      <span style={{ minWidth: 0 }}>{fmtTime(time.t)}</span>
      <span style={{ flex: 1 }} />
      <LiveButton live={live} style={b()} />
      <span style={{ fontSize: 11, color: '#5d6b88', whiteSpace: 'nowrap' }}>見る専用</span>
    </div>
  );
}
